import { createFileRoute, Link } from "@tanstack/react-router";
import { ctrDesc, ctrTitle } from "@/lib/seo-copy";
import { buildPriceMatrix } from "@/lib/naati/generator";
import { NAATI_DOC_TYPES } from "@/data/naati";
import { RelatedClusters } from "@/components/RelatedClusters";

export const Route = createFileRoute("/naati/price")({
  loader: () => ({ h: (() => ({
    meta: [
      { title: ctrTitle("ราคาแปล NAATI Certified — ราคาต่อหน้า ทุกประเภทเอกสาร | Thai Notary Law") },
      { name: "description", content: ctrDesc("แนวทางประเมินราคาแปล NAATI ตามประเภทเอกสาร จำนวนหน้า ความชัดเจน รูปแบบรับรอง และกำหนดส่ง พร้อมขอใบเสนอราคาก่อนเริ่มงาน") },
      { property: "og:title", content: ctrTitle("ราคาแปล NAATI Certified — ขอใบเสนอราคาตามเอกสาร | Thai Notary Law") },
      { property: "og:description", content: ctrDesc("ตรวจปัจจัยที่ใช้ประเมินราคาและระยะเวลาแปล NAATI ก่อนส่งไฟล์ขอใบเสนอราคา") },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
      { property: "og:url", content: "https://thainotarylaw.com/naati/price" },
    ],
    links: [{ rel: "canonical", href: "https://thainotarylaw.com/naati/price" }],
  }))() }),
  head: ({ loaderData }) => loaderData?.h ?? {},
  component: PricePage,
});

function PricePage() {
  const matrix = buildPriceMatrix();
  return (
    <article className="mx-auto max-w-4xl px-4 py-10 prose">
      <h1>ราคาแปล NAATI Certified — ประเมินตามเอกสารจริง</h1>
      <p className="lead">
        ค่าบริการขึ้นกับจำนวนหน้า ความชัดเจน ทิศทางภาษา คำศัพท์เฉพาะ รูปแบบคำรับรอง และกำหนดส่ง
        ทีมงานตรวจไฟล์ก่อนแจ้งขอบเขต ราคา และรูปแบบส่งมอบเป็นลายลักษณ์อักษร
      </p>
      <table>
        <thead>
          <tr>
            <th>ประเภทเอกสาร</th>
            <th>การประเมินราคา</th>
            <th>ระยะเวลา</th>
            <th>รายละเอียด</th>
          </tr>
        </thead>
        <tbody>
          {matrix.map((row, i) => {
            const doc = NAATI_DOC_TYPES[i]!;
            return (
              <tr key={row.slug}>
                <td>{row.name} <small>({doc.nameEn})</small></td>
                <td>สอบถามค่าบริการ (โทร · LINE · อีเมล)</td>
                <td>ยืนยันหลังตรวจไฟล์และคิวนักแปล</td>
                <td>
                  <Link to="/naati/services/$service" params={{ service: row.slug }}>
                    ดูรายละเอียด
                  </Link>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <h2>งานเร่งด่วน</h2>
      <ul>
        <li>แจ้งวันและเวลาที่ต้องใช้เอกสารพร้อมส่งไฟล์ให้ตรวจ</li>
        <li>ทีมงานยืนยันคิวนักแปลและกำหนดส่งก่อนรับงาน</li>
        <li>ค่าบริการเร่งด่วนหรือนอกเวลาจะแจ้งในใบเสนอราคา</li>
      </ul>
      <h2>ค่าจัดส่ง hard copy (โดยประมาณ)</h2>
      <ul>
        <li>เลือกผู้ขนส่งตามประเทศปลายทางและกำหนดใช้เอกสาร</li>
        <li>ค่าจัดส่งและระยะเวลาเป็นข้อมูลจากผู้ขนส่ง ณ วันที่ส่ง</li>
        <li>ทีมงานแจ้งเลขติดตามเมื่อรับพัสดุเข้าระบบแล้ว</li>
      </ul>
      <RelatedClusters theme="naati" />
    </article>
  );
}
